<template>
  <div class="all-information" v-loading="loading">
    <header-top></header-top>
    <div class="header-title">{{ headerText }}</div>
    <main>
      <div class="handle">
        <div class="left fl">
          <el-button type="primary" class="add" @click="createInformation"
            >添加新资讯</el-button
          >
          <!-- <el-button
            class="delete"
            @click="delInformation"
            :disabled="selectedInformation.length == 0"
            >删除</el-button
          > -->
          <!-- <el-button class="freeze">批量审核</el-button> -->
          <div class="divider"></div>
          <el-select
            v-model="inputValue"
            @change="informationTime"
            placeholder="请选择"
            class="handle-select "
            :class="{custom:inputValue !== 'all'}"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div v-if="inputValue !== 'all'">
            <el-date-picker
              class="filter-date"
              v-model="time"
              type="daterange"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getInformationList"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
        </div>
        <div class="right fr">
          <el-input
            placeholder="输入咨讯名称"
            v-model="query.name"
            @keyup.enter.native="getInformationList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getInformationList"
            ></el-button>
          </el-input>
          <!-- <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="90"
            height="49"
            trigger="hover"
            :content="`切换${coverShowTip}图模式`"
          >
            <div slot="reference">
              <div @click="showCover" class="cover-img">
                <svg-icon class="svg" icon-class="img-icon" v-if="coverShowTip=='有'"/>
                <svg-icon class="svg" icon-class="text-icon" v-if="coverShowTip=='无'"/>
              </div>
            </div>
          </el-popover>
          <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="30"
            height="49"
            trigger="hover"
            content="刷新"
          >
            <div slot="reference">
              <div @click="getInformationList">
                <svg-icon class="svg" icon-class="refresh-ico" />
              </div>
            </div>
          </el-popover>
          <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="30"
            height="49"
            trigger="hover"
            content="设置"
          >
            <div slot="reference">
              <div @click="showFiltrate = true">
                <svg-icon class="svg" icon-class="filtrate-ico" />
              </div>
            </div>
          </el-popover> -->
          <!-- <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="25"
            height="49"
            trigger="hover"
            content="下载"
          >
            <div slot="reference">
              <div @click="derive">
                <svg-icon class="svg" icon-class="derive-ico" />
              </div>
            </div>
          </el-popover> -->
        </div>
      </div>
      <!-- 筛选标签 -->
      <div class="tag-filter flex" v-if="statusType">
        <div style="font-weight: bold">当前已选条件：</div>
        <div class="item flex-between" v-if="statusType">
          <div>
            <span>发布状态：</span>
            <span class="keys">{{ statusType }}</span>
          </div>
          <div @click="clearFilters('status')">
            <svg-icon class="close" icon-class="close-ico"></svg-icon>
          </div>
        </div>

        <div class="clean" @click="clearFilters('all')">
          <svg-icon class="icon" icon-class="clean-ico"></svg-icon>清空条件
        </div>
      </div>
      <div class="main">
        <el-table
          class="list-table"
          :data="informationList"
          ref="filterTable"
          stripe
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          @filter-change="handleFilterChange"
        >
          <el-table-column type="selection" width="50" />
          <!--控制是否可以选择 :selectable='checkboxInit' -->
          <el-table-column
            label-class-name="tab-tit"
            label="封面"
            width="190"
            align="left"
            v-if="coverShowTip == '无'"
          >
            <template slot-scope="scope">
              <div class="name">
                <div class="cover">
                  <img
                    v-if="scope.row.imageUrls && scope.row.imageUrls.length > 0"
                    :src="scope.row.imageUrls[0]"
                    class="head-img"
                  />
                  <img v-else :src="defaultHead" class="head-img" />
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="tableTitleKey.includes('标题')"
            label-class-name="tab-tit"
            label="标题"
            width="250"
            show-overflow-tooltip
            align="left"
          >
            <template slot-scope="scope">
              <!-- <div class="tit-name" :class="{text:coverShowTip=='有'}"> -->
              {{ scope.row.name | valLength(15) }}
              <!-- <div v-if="scope.row.startTime">
                  {{ scope.row.startTime | nullValue }}
                </div> -->
              <!-- <div class="quick-view" @click="getInformation(scope.row)">
                  快捷查看
                </div> -->
              <!-- </div> -->
            </template>
          </el-table-column>
          <el-table-column
            v-if="tableTitleKey.includes('类型')"
            label-class-name="tab-tit"
            label="类型"
            min-width="50"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.type | nullValue }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="tableTitleKey.includes('生效时间')"
            prop="startTime"
            label-class-name="tab-tit"
            label="生效时间"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.startTime | nullValue }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="tableTitleKey.includes('阅读量')"
            label-class-name="tab-tit"
            label="阅读量"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.clickNum | nullValue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="tableTitleKey.includes('创建人')"
            label-class-name="tab-tit"
            label="创建人"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.creator | nullValue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="tableTitleKey.includes('摘要')"
            label-class-name="tab-tit"
            label="摘要"
            show-overflow-tooltip
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.summary | nullValue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="tableTitleKey.includes('状态')"
            label-class-name="tab-tit"
            label="状态"
            :filters="statusTypeOptions"
            :filter-multiple="false"
            column-key="statusType"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div class="table-icon">
                <svg-icon
                  class="svg"
                  v-if="scope.row.statusType == '未发布'"
                  icon-class="status-wait"
                />
                <svg-icon
                  class="svg"
                  v-else-if="scope.row.statusType == '已下架'"
                  icon-class="status-close"
                />
                <svg-icon
                  class="svg"
                  v-else-if="scope.row.statusType == '已发布'"
                  icon-class="success"
                />
                {{ scope.row.statusType | nullValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button
                  @click.native.prevent="contentInformation(scope.row.id)"
                  type="text"
                  >管理</el-button
                >
                <el-button type="text" @click="toPreview(scope.row)"
                  >预览</el-button
                >
                <el-dropdown
                  @command="handleCommand"
                  trigger="click"
                  placement="bottom"
                >
                  <span class="el-dropdown-link">更多</span>
                  <el-dropdown-menu slot="dropdown" class="opertion-dropdown">
                    <el-dropdown-item
                      :command="beforeHandleCommand(scope.row, 'status')"
                    >
                      <span v-if="scope.row.statusType != '已发布'">发布</span>
                      <span v-else>取消发布</span>
                    </el-dropdown-item>
                    <el-dropdown-item
                      :command="beforeHandleCommand(scope.row, 'delete')"
                    >
                      <span>删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !informationList.length">
              列表为空
            </div>
          </template>
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </main>
    <el-dialog
      title="自定义列表字段 "
      :visible.sync="showFiltrate"
      width="800px"
      :before-close="handleClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :filter-method="filterMethod"
        :titles="['请选择你想显示的列表字段', '已选择字段']"
        filter-placeholder="请输入字段名称"
        v-model="tableTitleKey"
        :data="tabTitData"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showFiltrate = false">取 消</el-button>
        <el-button type="primary" @click="submitTable">确定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      :title="information.name"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{ information.name }}
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form label-position="left" label-width="6rem">
        <div class="basic-item">
          <div class="basic-item-title basic-title-edit">
            基本信息
            <div class="basic-edit" @click="contentInformation(information.id)">
              修改
            </div>
          </div>
          <div class="basic-item-main">
            <el-form :model="information" ref="information" label-width="6rem">
              <div class="information">
                <el-form-item label="标题" prop="name" class="auto-height">
                  {{ information.name | nullValue }}
                </el-form-item>
                <el-form-item label="摘要" prop="summary" class="auto-height">
                  {{ information.summary | nullValue }}
                </el-form-item>
                <el-form-item label="类型" prop="type">
                  {{ information.type | nullValue }}
                </el-form-item>
                <el-form-item label="阅读量" prop="clickNum">
                  {{ information.clickNum | nullValue }}
                </el-form-item>
                <el-form-item label="来源" prop="source">
                  {{ information.source | nullValue }}
                </el-form-item>
                <el-form-item label="关键词" prop="keyWord" class="auto-height">
                  {{ information.keyWord | nullValue }}
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                  {{ information.sort | nullValue }}
                </el-form-item>

                <el-form-item label="发布时间" prop="sort">
                  {{ information.startTime | nullValue }}
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import {
  getInformationList,
  getInformation,
  deleteInformationList,
  updateStatus,
} from "@/http/api/information";
import {
  getUsers,
  //   delUser,
  deleteInformation,
  getUserJobs,
  //   userLockout,
} from "@/http/api/information";

import { deepCopy } from "@/utils/deepCopy";
import { getPostAllTree } from "@/http/api/position";
import headerTop from "@/components/HeaderTop";
import { getEnumMetaKey } from "@/utils/getEnumMeta";
export default {
  data() {
    const generateData = (_) => {
      const data = [];
      const tabTits = [
        "标题",
        "类型",
        // "联系电话",
        "生效时间",
        "阅读量",
        "创建人",
        "摘要",
        "状态",
      ];
      const pinyin = [
        "biaoti",
        "leixing",
        // "lianxidianhua",
        "kaishishijian",
        "dianjicishu",
        "chuangjianren",
        "beizhu",
        "zhuangtai",
      ];
      tabTits.forEach((tabTit, index) => {
        data.push({
          label: tabTit,
          key: tabTit,
          pinyin: pinyin[index],
        });
      });
      return data;
    };
    return {
      loading: false,
      information: {}, // 资讯对象
      headerText: "资讯管理",
      statusTypeOptions: [],
      isShow: {
        identityCard: false,
        phoneNumber: false,
        emergencyPhoneNumber: false,
      }, // 显示加密字段
      defaultHead: require("../../assets/image/default-img.png"),
      tabTitData: generateData(),
      tableTitleKey: [
        "标题",
        "类型",
        // "联系电话",
        "生效时间",
        "阅读量",
        "创建人",
        "摘要",
        "状态",
      ],
      isDrawerShow: false,
      inputValue: "all",
      searchFilter: "",
      searchSelect: "请输入姓名前缀",
      time: null,
      informationList: [],
      showFiltrate: false,
      isLoading: true,
      selectedInformation: [],
      total: 0,
      query: {
        status: "",
        timeCondition: "",
        skipCount: 0,
        startTime: "",
        endTime: "",
        maxResultCount: 30,
        condition: "",
        name: "",
        sorting: "creationTime desc",
      },
      coverShowTip: "有",
      statusType: "",
      pageIndex: 1,
      dialogTit: "资讯审核",
      options: [
        {
          value: "all",
          label: "全部时间",
        },
        {
          value: "startTime",
          label: "发布时间",
        },
      ],
      permissions: this.$store.getters.permissions,
    };
  },
  components: {
    headerTop,
  },

  mounted() {
    this.getInformationList();
    let informationStatusTypeDic = this.$store.getters.enumMetadata
      .InformationStatusType;
    for (var key in informationStatusTypeDic) {
      this.statusTypeOptions.push({
        text: informationStatusTypeDic[key],
        value: key,
      });
    }
  },
  methods: {
    showCover() {
      this.coverShowTip = this.coverShowTip == "有" ? "无" : "有";
    },
    // 列表搜索
    handleFilterChange(filters) {
      console.log(filters);
      if (filters.statusType) {
        this.query.statusType = filters.statusType[0];
        this.statusType = getEnumMetaKey(
          this.$store.getters.enumMetadata,
          "InformationStatusType",
          filters.statusType[0]
        );
        console.log(this.statusType, 999);
      }
      this.getInformationList();
    },
    //清空筛选条件
    clearFilters(type) {
      if (type == "status") {
        this.statusType = "";
        this.query.statusType = "";
        this.$refs.filterTable.clearFilter("statusType");
      } else {
        this.statusType = "";
        this.query.statusType = "";
        this.$refs.filterTable.clearFilter("statusType");
      }
      this.getInformationList();
    },
    changeStatus(item) {
      if (this.permissions["Information.Update"]) {
        let status = "";
        let title = "";
        if (item.statusType == "已发布") {
          status = "UnShelved";
          title = "取消发布";
        } else {
          status = "Published";
          title = "发布";
        }
        this.$confirm(`你确定要${title}吗?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateStatus(item.id, status).then((res) => {
              if (res.code == 10200) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
                this.getInformationList();
              }
            });
          })
          .catch((err) => {});
      } else {
        this.$message.warning({
          message: "您暂无管理资讯权限",
          showClose: true,
        });
      }
    },
    getInformation(row) {
      getInformation(row.id).then((res) => {
        if (res && res.result) {
          this.information = res.result;
          this.isDrawerShow = true;
        }
      });
    },
    submitTable() {
      this.showFiltrate = false;
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    toPreview(row) {
      this.$router.push({
        path: `information-preview/${row.id}`,
      });
    },

    handleCommand(command) {
      if (command.command == "delete") {
        this.delInformation(command.row);
      } else if (command.command == "status") {
        this.changeStatus(command.row);
      }
    },

    // 获取选择项
    handleSelectionChange(val) {
      this.selectedInformation = val.map((item) => {
        return item.id;
      });
    },
    // 批量删除资讯
    // delInformation() {
    //   //   if (this.permissions["RocketIdentity.Users.Delete"]) {
    //   this.$confirm(`此操作将删除资讯信息, 请谨慎操作?`, "温馨提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //   })
    //     .then(() => {
    //       let data = "";
    //       this.selectedInformation.forEach((element) => {
    //         data = `ids=${element}&${data}`;
    //       });
    //       deleteInformationList(data).then((res) => {
    //         if (res && res.result) {
    //           this.$message.success({
    //             message: "资讯删除成功",
    //             showClose: true,
    //           });
    //           this.getInformationList();
    //         }
    //       });
    //     })
    //     .catch(() => {
    //       //console.log("已取消");
    //     });
    //   //   } else {
    //   //     this.$message.warning({
    //   //       message: "您暂无删除资讯权限",
    //   //       showClose: true,
    //   //     });
    //   // }
    // },
    // 删除资讯
    delInformation(row) {
      if (this.permissions["Information.Delete"]) {
        this.$confirm(`此操作将永久删除${row.name}, 是否继续?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            //console.log("delete");
            deleteInformation(row.id).then((res) => {
              if (res && res.result) {
                this.$message.success({
                  message: "资讯删除成功",
                  showClose: true,
                });
                this.getInformationList();
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除资讯权限",
          showClose: true,
        });
      }
    },

    //管理正文
    contentInformation(id) {
      if (this.permissions["Information.Update"]) {
        this.$router.push({
          path: `information-content/${id}`,
        });
      } else {
        this.$message.warning({
          message: "您暂无管理资讯权限",
          showClose: true,
        });
      }
    },
    // 选择时间搜索
    informationTime(val) {
      this.query.timeCondition = val;
      if (val === "all") {
        this.time = null;
        this.getInformationList();
      } else {
      }
    },

    cleanSearch() {
      // this.$refs.filter.columnConfig.filteredValue = [];
      this.$refs.tree.setCheckedKeys([]);
      this.query.type = "";
      this.query.startTime = "";
      this.query.endTime = "";
      this.inputValue = "all";
      this.time = [];
      this.getInformationList();
    },
    derive() {
      //console.log("导出");
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.getInformationList();
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.pageIndex = val;
      this.getInformationList();
    },

    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1 || item.label.indexOf(query) > -1;
    },
    handleClose() {
      this.showFiltrate = false;
    },

    // 获取资讯列表
    getInformationList(v) {
      this.isLoading = true;
      this.informationList = [];
      if (this.time != "" && this.time != null) {
        this.query.startTime = this.time[0];
        this.query.endTime = this.time[1];
      } else {
        this.query.timeCondition = "";
        this.query.startTime = null;
        this.query.endTime = null;
      }
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      getInformationList(this.query).then((res) => {
        this.isLoading = false;
        if (res && res.result) {
          this.informationList = res.result.items;
          this.total = res.result.totalCount;
        }
      });
    },
    createInformation() {
      if (this.permissions["Information.Create"]) {
        this.$router.push({
          path: `information-create`,
        });
      } else {
        this.$message.warning({
          message: "您暂无添加新资讯权限",
          showClose: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.handle {
  width: 100%;
  height: 40px;
  min-width: 760px;
  .left,
  .right {
    display: flex;
    align-items: center;
    ::v-deep .handle-select {
      margin-left: 10px;
      &.time {
        width: 120px;
      }
      &.custom {
        .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .filter-date {
      border-left-color: transparent;
      border-radius: 0px 4px 4px 0;
      &:hover {
        border-color: #ddd;
        border-left-color: transparent;
      }
      &.isactive {
        border-color: $--color-primary;
      }
    }
  }

  .right {
    margin-right: 7px;
    width: 256px;
    justify-content: space-between;
    .btn-group-right-btn {
      margin-left: 10px;
      .svg {
        width: 12px;
        height: 16px;
        cursor: pointer;
      }
      .cover-img {
        .svg {
          width: 18px;
          height: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.search-view {
  border-top: solid 1px #dddddd;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ul {
    padding: 0;
    display: flex;
    align-items: center;
  }
  li {
    margin-right: 10px;
    padding: 5px 10px;
    background: #fff;
    font-size: 12px;
    color: #000000;
    border: 1px solid rgba(204, 204, 204, 1);
    div {
      position: relative;
      left: 2px;
      top: -2px;
      display: inline-block;
      width: 8px;
      height: 8px;
    }
    .position-search,
    .post-search {
      margin-right: 5px;
    }
    .svg {
      width: 8px;
      height: 8px;
      cursor: pointer;
    }
  }
  .clean {
    cursor: pointer;
    margin-left: 10px;
  }
}

main {
  margin: 20px;
  padding: 20px;
  // width: calc(100% - 40px);
  background: #fff;
  .tag-filter {
    padding: 14px 0;
    color: #000;
    border-top: 1px solid #ddd;

    .item {
      height: 24px;
      border: 1px solid #ccc;
      padding: 0 10px;
      box-sizing: border-box;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        background: #fafafa;
      }
      .close {
        width: 8px;
        height: 8px;
        cursor: pointer;
      }
      .keys {
        padding: 0 4px;
      }
    }

    .clean {
      cursor: pointer;
      padding-left: 15px;
      color: #434343;

      .icon {
        width: 14px;
        height: 12px;
        margin-right: 6px;
      }
    }
  }
  .name {
    .head-img {
      width: 160px;
      height: 120px;
      margin-right: 10px;
    }
  }
  .tit-name {
    @include flex(column, flex-start);
    justify-content: space-around;
    // height: 90px;
    .quick-view {
      // display: none;
      color: $--color-primary;
      opacity: 0;
      cursor: pointer;
    }
  }
  .text {
    height: 60px;
  }
  .el-table__row:hover {
    .quick-view {
      opacity: 1;
      // display: block;
    }
  }
  .pagination {
    padding: 20px 10px 0;
  }

  .list-table {
    .name,
    .status {
      display: flex;
      line-height: 19px;
    }
    ::v-deep .el-dropdown {
      span {
        cursor: pointer;
        margin-left: 10px;
        color: $--color-primary;
      }
    }
    .status {
      // @include flex(,center);
      justify-content: center;
    }

    ::v-deep .el-table {
      .el-table__body-wrapper {
        min-height: calc(100vh - 315px);
      }
    }
  }
}
/* 已发布样式 */
.cell {
  .table-icon {
    @include flex(row, center);
    justify-content: center;
    .svg {
      margin-right: 7px;
    }
  }
}
.el-dialog {
  .dialog-tip {
    margin-top: -3px;
    width: 504px;

    font-size: 12px;
    font-weight: 400;
    line-height: 18px;

    color: #e6a23c;
  }

  .positive-date {
    margin-top: -5px;
  }

  .margin-bottom {
    margin-bottom: 22px;
  }
}
::v-deep .el-drawer {
  width: 550px !important;
  .basic-item {
    margin-bottom: 5px;

    .basic-item-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .basic-title-edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .basic-edit {
        font-size: 14px;
        font-weight: 400;
        color: $--color-primary;
        cursor: pointer;
      }
    }

    .basic-item-main {
      display: flex;

      .main-item {
        width: 50%;

        .el-select,
        .el-input {
          width: 330px;
        }

        .work-card {
          .work-card-item {
            margin-bottom: 15px;
            line-height: 0;

            .work-card-img {
              width: 143px;
              height: 148px;
            }
          }

          .work-card-print {
            margin-bottom: 0;
          }
        }

        .encrypt-number {
          display: flex;

          span {
            display: inline-block;
            width: 115px;
          }

          .show-svg {
            margin-left: 8px;

            .svg-icon {
              margin-top: -2px;
              cursor: pointer;
            }
          }
        }

        .phone-number {
          span {
            width: 75px;
          }
        }

        .job-num-box {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          color: #000;
          vertical-align: middle;

          p {
            margin: 0;
          }

          .job-num-btn {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $--color-primary;
          }
        }

        .account-lock {
          display: inline-block;
          margin-right: 5px;
        }
      }

      .basic-item-right {
        padding-left: 50px;
      }

      .el-form-item {
        height: 30px;
        margin-bottom: 14px;
      }
    }

    .el-table {
      margin-bottom: 25px;
      .table-empty {
        color: $--color-primary;
        cursor: pointer;
      }
      .grade-box {
        @include flex(row, baseline);
        .grade-main {
          margin-left: 9px;
          border: 1px solid $--color-primary;
          padding: 0 5px;

          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: $--color-primary;
        }
      }
    }
  }

  .margin-bottom {
    margin-bottom: 0;
  }
  .lockout-box {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 5px;
    }
  }

  .is-lockout {
    color: #f44242;
  }

  .not-lockout {
    color: #0abf5b;
  }
}
::v-deep .el-input-group__append {
  background-color: $--color-primary;
  border-color: $--color-primary;

  &:hover {
    background-color: $--color-primary;
  }

  .el-button {
    margin: -10px;

    &:hover,
    &:focus {
      border-color: transparent;
      background-color: transparent;
    }
  }

  i {
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}
::v-deep .information-dialog {
  .el-dialog__header {
    padding: 25px 25px 20px 25px;
  }
  .el-dialog__body {
    padding: 0 25px;
  }
  .el-dialog__footer {
    padding: 15px 25px 25px 25px;

    .upload-btn {
      margin-right: 10px;
    }
  }
}
::v-deep .examine-dialog {
  .el-dialog__header {
    @include flex(row, center);
    padding: 25px 25px 20px 25px;
    .el-dialog__headerbtn {
      top: 27px;
    }
  }
  .el-dialog__body {
    padding: 0 25px;
    color: #666;
  }
  .el-dialog__footer {
    padding: 15px 25px 25px 25px;
  }
  .upload-btn {
    margin-right: 10px;
  }
  .el-textarea {
    width: 396px;
  }
  .no-margin-bototm {
    margin-bottom: 0;
  }
}
</style>

